const ONGOING = 'ongoing'
const COMPLETED = 'completed'

const eventStatus = {
  'scheduled': 'Upcoming',
  'in_progress': 'Ongoing',
  'completed': 'Completed',
  'cancelled': 'Cancelled',
  'failed': 'Failed',
  'stopped': 'Stopped',
  'deleted': 'Deleted',
  'scheduling': 'scheduling',
  'OPTEDOUT': 'optedout'
}

const EVENT_TYPE = {
  'BATTERY_DISCHARGE': 'Discharge Event',
  'BATTERY_CHARGE': 'Charge Event',
  'IDLE': 'Idle Event',
  'battery_discharge': 'Discharge Event',
  'battery_charge': 'Charge Event',
}

const getEventsTableHeadings = (type) => ([
  {
    id: 'sno',
    header: 'S.NO.',
  },
  {
    id: 'program_name',
    header: 'PROGRAM NAME',
    isLink: true
  },
  {
    id: 'event_name',
    header: 'EVENT NAME',
    isLink: true
  },
  {
    id: 'event_type',
    header: 'EVENT TYPE',
  },
  {
    id: 'start_time',
    header: 'EVENT START TIME',
  },
  {
    id: 'end_time',
    header: 'EVENT END TIME',
  },
  {
    id: 'duration',
    header: 'EVENT DURATION'
  },
  {
    id: 'status',
    header: 'EVENT STATUS'
  }
])

export {
  ONGOING,
  COMPLETED,
  EVENT_TYPE,
  eventStatus,
  getEventsTableHeadings,
}



